export const getDollarValue = (value: any) => `$${(value / 10000).toFixed(3)}`
